import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateReturnOrder from "../pages/ReturnOrder/CreateReturnOrder";
import EditReturnOrder from "../pages/ReturnOrder/EditReturnOrder";
import ReturnOrdertList from "../pages/ReturnOrder/ReturnOrderList";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                children={<ReturnOrdertList />}
                allowedPermissions={["can_view_rtv_return"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditReturnOrder />}
                allowedPermissions={["can_view_rtv_return"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateReturnOrder />}
                allowedPermissions={["can_create_rtv_return"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
